<template lang="pug">
  .team-view-all
    WtTitle(h1) {{ team.name }}
    BLoading(:active="!teamMembersLoaded")
    TeamAllMembers(
      v-if="teamMembersLoaded"
      :members="teamMembers"
      :pagination="teamMembersPagination"
      @page-change="onPageChange"
    )

</template>

<script>
import { mapActions } from "vuex";
import analyticsTrackingMixin from "@/mixins/analyticsTrackingMixin";
import WtTitle from "@@/WtTitle/WtTitle";
import TeamAllMembers from "@@/Teams/TeamAllMembers";

export default {
  name: "TeamViewAll",

  components: {
    TeamAllMembers,
    WtTitle
  },

  mixins: [analyticsTrackingMixin],

  data() {
    return {
      team: {
        id: null,
        name: null,
        description: null,
        public: null,
        inviteOnly: null,
        logo: null,
        maxMembers: null,
        numMembers: null
      },
      teamLoaded: false,
      teamMembers: [],
      teamMembersLoaded: false,
      teamMembersPagination: {
        currentPage: 1,
        total: 0,
        perPage: 15
      }
    };
  },

  methods: {
    ...mapActions("teams", ["teamShow", "fetchTeamMembers"]),

    onPageChange(page) {
      this.teamMembersLoaded = false;
      this.fetchTeamMembers({
        teamId: this.team.id,
        perPage: this.teamMembersPagination.perPage,
        page
      }).then(response => {
        this.teamMembers = response.data.data;
        this.$set(
          this.teamMembersPagination,
          "currentPage",
          response.data.pagination.currentPage
        );
        this.$set(
          this.teamMembersPagination,
          "total",
          response.data.pagination.total
        );
        this.$set(
          this.teamMembersPagination,
          "perPage",
          response.data.pagination.perPage
        );
        this.teamMembersLoaded = true;
      });
    }
  },

  beforeRouteEnter(to, _, next) {
    next(async vm => {
      vm.trackFeatureView("teams", "team_members");
      vm.team = await vm.teamShow({ teamId: vm.$route.params.teamId });
      vm.teamLoaded = true;
      vm.fetchTeamMembers({
        teamId: vm.team.id,
        perPage: vm.teamMembersPagination.perPage
      }).then(response => {
        vm.teamMembers = response.data.data;
        vm.teamMembersPagination = {
          currentPage: response.data.pagination.currentPage,
          total: response.data.pagination.total,
          perPage: response.data.pagination.perPage
        };
        vm.teamMembersLoaded = true;
      });
    });
  }
};
</script>

<style lang="sass"></style>
